export default "__VITE_ASSET__DfKn3cr7__"